import React, { useEffect, useState } from "react";
import GridContainer, { GridOffset } from "@insite/mobius/GridContainer";
import CustomModelRecap from "./ADICustomModalRecap";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Select from "@insite/mobius/Select";
import styled from "styled-components";
import { css } from "styled-components";
import { CreditCardDtoCollection, updateSavedCreditCards } from "@NA/Services/SavedCreditCardsService";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import Icon from "@insite/mobius/Icon";
import ValidationSuccessIcon from "@NA/Icons/ValidationSuccessIcon";
import { checkExpirationDate, removeZeroPrefix } from "@NA/Utils/Utility";
import IconErrorCircle from "@NA/Icons/IconErrorCircle";
import ADIColors from "@NA/Utils/ADIColors";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";



export interface AdiEditCreditCardModalStyles {
    editListContainer?: InjectableCss;
    editInputWapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
    primaryButton?: ButtonPresentationProps;
    secondaryButton?: ButtonPresentationProps;
    buttonGridItem?: GridItemProps;
    okButton?: InjectableCss;
    dropdownContainer?: InjectableCss;
    dropdownValue?: InjectableCss;
    dropdownList?: InjectableCss;
    dropdownValues?: InjectableCss;
    dropdownLabel?: InjectableCss;
    icon?: InjectableCss;
    modalStyle?: ModalPresentationProps;
    validationErrorMessage?: InjectableCss;
}

export const adiEditCreditCardModalStyles: AdiEditCreditCardModalStyles = {
    editListContainer: {
        css: css`
            max-width: 355px !important;
            margin-top: 10px;
            > ${GridOffset} {
                > ${GridItemStyle} {
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 0px;
                    padding-top: 10px;
                }
            }
        `,
    },
    labelText: {
        css: css`
            margin-bottom: 2px;
            min-height: 19px;
            font-weight: 800;
            line-height: normal;
            color: ${getColor("text.main")};
        `,
    },
    valueText: {
        css: css`
            color: ${getColor("text.accent")};
            line-height: 20px;
            font-size: 14px;
        `,
    },
    editInputWapper: {
        css: css`
            display: flex;
            margin-bottom: 20px;
            width: 100%;
            gap: 15px;
        `,
    },
    buttonGridItem: {
        css: css`
            flex-direction: row !important;
            justify-content: end;
            gap: 10px;
            margin-bottom: 20px !important;
        `,
    },
    primaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    secondaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    okButton: {
        css: css`
            border-radius: 4px;
            width:  100%;
        `
    },
    dropdownContainer: {
        css: css`
            position: relative;
            width: 100%;
        `,
    },
    dropdownValue: {
        css: css`
            width: 100%;
            border: 1px solid;
            border-radius: 6px;
            padding: 9px 9px 9px 15px;
            margin: 5px 0px 3px 0px;
            height: 40px;
            background: ${ADIColors.white};
            border: 1px solid ${ADIColors.gray3};
            font-size: 14px;
            cursor: pointer;
            position: relative;
            z-index: 10;
            display: flex;
            align-items: normal;
            justify-content: space-between;
        `,
    },
    dropdownList: {
        css: css`
            border-radius: 0 0 7px 7px;
            box-shadow: 1px 2px 14px 4px rgba(57, 57, 58, 0.25);
            background: ${ADIColors.white};
            position: absolute;
            width: 100%;
            top: 90%;
            z-index: 9;
            height: auto;
            max-height: 188px;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 8px;
                -webkit-appearance: none;
            }
            &::-webkit-scrollbar-thumb{
                border-radius: 7px;
                background: #7c93ad;
            }
            &::-webkit-scrollbar-track{
                background: #ececec;
                border-radius: 7px;
            }
        `,
    },
    dropdownValues: {
        css: css`
            min-height: 40px;
            border-bottom: 1px solid ${ADIColors.gray3};
            font-weight: 600;
            padding: 13px 12px;
            font-size: 14px;
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
                border-radius: 0 0 7px 7px;
            }

            &.active,
            &:hover {
                background-color: ${ADIColors.blue1};
                color: ${ADIColors.white};
            }
        `,
    },
    icon: {
        css: css`
            transform: translateY(-1px) scale(0.9);
            svg {
                stroke: ${ADIColors.darkBlue1};
            }
        `,
    },
    modalStyle: {                
            cssOverrides: {               
                modalContainer: css`
                overflow-y: visible !important;

                > div[class^="ContentBody"] {
                    overflow-y: visible !important;
                }                
            `, 
                                    
        },
    },    
    validationErrorMessage: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            color: ${ADIColors.black} !important;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            margin-left: 15px;
        `,
    },
};

const SuccessMessage = styled.div`
padding: 2px;
display: flex;
margin: 5px 0 7px;
gap: 15px;
margin-bottom: 20px;
`;

const styles = adiEditCreditCardModalStyles;

interface OwnProps {
    savedCardData: CreditCardDtoCollection;
    closeEditCard: Function;
    getApi: Function;
    isEditCardOpen: boolean;
    expirationMonths: { key: string; value: number }[] | null | undefined;
    expirationYears: { key: number; value: number }[] | null | undefined;
}

type Props = OwnProps;

const ADIEditCreditCardModal = ({
    savedCardData,
    isEditCardOpen,
    closeEditCard,
    getApi,
    expirationMonths,
    expirationYears
}: Props) => {
    const [updateExpMonth, setUpdateExpMonth] = useState(savedCardData?.expiryMonth);
    const [updateExpYear, setUpdateExpYear] = useState(savedCardData?.expiryYear);
    const [isSuccess,setIsSuccess] = useState(false);   
    const [openCCExpMonth, setOpenCCExpMonth] = React.useState(false);
    const [openCCExpYear, setOpenCCExpYear] = React.useState(false);
    const [isExpired, setIsExpired] = useState(false);
    const [ccNumber, setCCNumber] = useState("");
   
    useEffect(()=>{
        setUpdateExpMonth(savedCardData?.expiryMonth);
        var d = new Date();
        var x = savedCardData?.expiryYear.length == 2 ? `20${savedCardData?.expiryYear}` : savedCardData?.expiryYear;
        setUpdateExpYear(x);
        setIsExpired(checkExpirationDate(updateExpMonth, updateExpYear));
        setIsSuccess(false);
        setOpenCCExpMonth(false);
        
    },[savedCardData?.expiryMonth,savedCardData?.expiryYear])

    // For New CC Changes ---- P21 Changes
    useEffect(() =>{
        let ccNum = savedCardData.cardNumber.slice(savedCardData.cardNumber.length - 4);
        setCCNumber(ccNum);
    },[])

    const handleUpdateExpMonth = (value : any) => {
        {Number(value) <= 9 ?  setUpdateExpMonth(`0${value}`): setUpdateExpMonth(value) }
        setOpenCCExpMonth(false);      
    };
    const handleUpdateExpYear = (value : any) => {
        
        setUpdateExpYear(value);
        setOpenCCExpYear(false);      
    };
    const MonthRef = React.useRef(null);
    const YearRef = React.useRef(null);
    useOutsideAlerter(MonthRef, setOpenCCExpMonth);
    useOutsideAlerter(YearRef, setOpenCCExpYear);

    function useOutsideAlerter(ref: any, setaction: any) {
        React.useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setaction(false);
                }
            }
    
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    const updateSavedCard = async () => {
        const isExpired = checkExpirationDate(
            parseInt(updateExpMonth).toString(),
            updateExpYear.toString().substring(2, 4),
        );
        if (!savedCardData) return;
        if (isExpired) {
            setIsExpired(true);
            return;
        }
        try {
            const { cardType, cardNumber, cardToken, id, creditCardBankNumber,
                paymentMethodId, paymentTypeDesc, paymentTypeId, period, yearForPeriod
              } = savedCardData;
           const result =  await updateSavedCreditCards({
                uri: null,
                cardType,
                cardNumber,
                cardToken,
                //expiryMonth: parseInt(updateExpMonth).toString(),
                expiryMonth: updateExpMonth.toString().substring(0, 2),
                expiryYear: parseInt(updateExpYear).toString(),
                isDefault: false,
                cardCVC: null,
                postalCode: null,
                id,
                properties: {},
                creditCardBankNumber,
                paymentMethodId,
                paymentTypeDesc,
                paymentTypeId,
                period,
                yearForPeriod,
            });
            setIsSuccess(true);
            getApi();
        } catch (error) {
            setIsSuccess(false);
            throw error;
        }
    };
    
    const handleCloseModal = () => {
        setIsSuccess(false);
        closeEditCard();
        setIsExpired(false);
    };

    const isValidYear = (year: string) => {
        const currentYear = new Date().getFullYear();
        const parsedYear = parseInt(year, 10);
        return !isNaN(parsedYear) && parsedYear >= currentYear;
    };

    return (
        <CustomModelRecap
            {...styles.modalStyle}
            headline={`Edit Card **** ${ccNumber}`}
            isOpen={isEditCardOpen}
            errorStyle={false}
            handleClose={closeEditCard}
                           
        >
            <>
                {savedCardData && !isSuccess && (
                    <GridContainer {...styles.editListContainer}>
                        {isExpired &&
                            <Typography size={14} {...styles.validationErrorMessage}>
                                <Icon width={15} src={IconErrorCircle} />
                                {translate("Please Enter Valid Credit Card information.")}
                            </Typography>
                        }
                        <GridItem width={6}>
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Expiration Month *")}
                            </Typography>
                            <StyledWrapper {...styles.dropdownContainer} ref={MonthRef}>
                                    <StyledWrapper {...styles.dropdownValue} onClick={() => setOpenCCExpMonth(!openCCExpMonth)}>
                                    {updateExpMonth}
                                        <Typography {...styles.icon}>
                                            <ChevronDown />
                                        </Typography>
                                    </StyledWrapper>
                                    {openCCExpMonth ? (
                                        <StyledWrapper {...styles.dropdownList} as={"ul"}>
                                        { expirationMonths &&
                                        expirationMonths.length > 0 &&
                                        expirationMonths.map(item => (                                      
                                            <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => handleUpdateExpMonth(item.value)}                                               
                                                >
                                                    {item.value <= 9 ? `0${item.value}`:item.value} - {item.key}
                                            </StyledWrapper>
                                        ))}
                                        </StyledWrapper>                                   
                                    ) : null }                                    
                            </StyledWrapper>
                        </GridItem>
                        <GridItem width={6}>
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Expiration Year *")}
                            </Typography>
                            <StyledWrapper {...styles.dropdownContainer} ref={YearRef}>
                                    <StyledWrapper {...styles.dropdownValue} onClick={() => setOpenCCExpYear(!openCCExpYear)}>
                                    {updateExpYear}
                                        <Typography {...styles.icon}>
                                            <ChevronDown />
                                        </Typography>
                                    </StyledWrapper>
                                    {openCCExpYear ? (
                                        <StyledWrapper {...styles.dropdownList} as={"ul"}>
                                        { expirationYears &&
                                        expirationYears.map(item => (                                      
                                            <StyledWrapper
                                                    {...styles.dropdownValues}
                                                    as={"li"}
                                                    onClick={() => handleUpdateExpYear(item.value)}                                               
                                                >
                                                    {item.value}
                                            </StyledWrapper>
                                        ))}
                                        </StyledWrapper>                                   
                                    ) : null }                                    
                            </StyledWrapper>
                        </GridItem>
                        <GridItem width={12} {...styles.buttonGridItem}>
                            <Button onClick={() => handleCloseModal()} variant="secondary" {...styles.secondaryButton}>
                                {translate("Cancel")}
                            </Button>
                            <Button onClick={() => updateSavedCard()} variant="primary" {...styles.primaryButton}>
                                {translate("Save")}
                            </Button>
                        </GridItem>
                    </GridContainer>
                )}

                {isSuccess &&
                <>
                    <SuccessMessage>
                        <Icon src={ValidationSuccessIcon}/>
                        <Typography>
                            {translate("Your card information has been saved.")}
                        </Typography>
                    </SuccessMessage>
                    <Button onClick={() => handleCloseModal()} variant="primary" {...styles.okButton}>
                        {translate("Ok")}
                    </Button>
                </>
                }
                

            </>
        </CustomModelRecap>
    );
};

export default ADIEditCreditCardModal;
